var _regeneratorRuntime = require("C:\\Users\\vinayak\\Documents\\GitHub\\Barcode_reader_PWA\\barcode-reader\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\vinayak\\Documents\\GitHub\\Barcode_reader_PWA\\barcode-reader\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var Jimp = require('jimp');

var isNode = typeof process === 'object' && process.release && process.release.name === 'node'; // check if string is url

function isUrl(s) {
  var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return !s[0] === '#' || regexp.test(s);
}
/**
 * Creates image data from HTML image
 * @param {HTMLImageElement} image HTML Image element
 */


function createImageData(image) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var width = image.naturalWidth;
  var height = image.naturalHeight;
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(image, 0, 0);
  return ctx.getImageData(0, 0, image.naturalWidth, image.naturalHeight);
}
/**
 * Reads image source and returns imageData as only callback parameter
 * @param {*} source Image source
 * @param {Function} callback Callback to pass the imageData
 */


function getImageDataFromSource(_x) {
  return _getImageDataFromSource.apply(this, arguments);
}

function _getImageDataFromSource() {
  _getImageDataFromSource = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(source) {
    var isStringSource, isURLSource, tagName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isStringSource = typeof source === 'string';
            isURLSource = isStringSource ? isUrl(source) : false;
            tagName = source.tagName;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              // String source
              if (isStringSource) {
                // Read file in Node.js
                if (isNode) {
                  Jimp.read(isURLSource ? {
                    url: source,
                    headers: {}
                  } : source, function (err, image) {
                    if (err) {
                      reject(err);
                    } else {
                      var _image$bitmap = image.bitmap,
                          data = _image$bitmap.data,
                          width = _image$bitmap.width,
                          height = _image$bitmap.height;
                      resolve({
                        data: data.toJSON().data,
                        width: width,
                        height: height
                      });
                    }
                  });
                } else if (isURLSource) {
                  // Load Image from source
                  var img = new Image();
                  img.onerror = reject;

                  img.onload = function () {
                    return resolve(createImageData(img));
                  };

                  img.src = source;
                } else {
                  // Find Elment by ID
                  var imgElem = document.getElementById(source);

                  if (imgElem) {
                    resolve(createImageData(imgElem));
                  }

                  reject(new Error('Invalid image source specified!'));
                }
              } else if (tagName) {
                // HTML Image element
                if (tagName === 'IMG') {
                  resolve(createImageData(source));
                } // HTML Canvas element
                else if (tagName === 'CANVAS') {
                    resolve(source.getContext('2d').getImageData(0, 0, source.naturalWidth, source.naturalHeight));
                  }

                reject(new Error('Invalid image source specified!'));
              } // Pixel Data
              else if (source.data && source.width && source.height) {
                  resolve(source);
                } else {
                  reject(new Error('Invalid image source specified!'));
                }
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getImageDataFromSource.apply(this, arguments);
}

function getLines(obj) {
  var data = obj.data,
      start = obj.start,
      end = obj.end,
      channels = obj.channels,
      width = obj.width;
  var pxLine = data.slice(start, end);
  var sum = [];
  var bmp = [];
  var lines = [];
  var count = 1;
  var min = 0;
  var max = 0;
  var padding = {
    left: true,
    right: true // grey scale section and sum of columns pixels in section

  };

  for (var row = 0; row < 2; row += 1) {
    for (var col = 0; col < width; col += 1) {
      var i = (row * width + col) * channels;
      var g = (pxLine[i] * 3 + pxLine[i + 1] * 4 + pxLine[i + 2] * 2) / 9;
      var s = sum[col];
      pxLine[i] = g;
      pxLine[i + 1] = g;
      pxLine[i + 2] = g;
      sum[col] = g + (s || 0);
    }
  }

  for (var _i = 0; _i < width; _i += 1) {
    sum[_i] /= 2;
    var _s = sum[_i];

    if (_s < min) {
      min = _s;
    } else {
      max = _s;
    }
  } // matches columns in two rows


  var pivot = min + (max - min) / 2;

  for (var _col = 0; _col < width; _col += 1) {
    var matches = 0;
    var value = void 0;

    for (var _row = 0; _row < 2; _row += 1) {
      value = pxLine[(_row * width + _col) * channels];

      if (value > pivot) {
        matches += 1;
      }
    }

    if (_col === 0 && value <= pivot) padding.left = false;

    if (_col === width - 1 && value <= pivot) {
      padding.right = false;
    }

    bmp.push(matches > 1);
  } // matches width of barcode lines


  var curr = bmp[0];

  for (var _col2 = 0; _col2 < width; _col2 += 1) {
    if (bmp[_col2] === curr) {
      count += 1;

      if (_col2 === width - 1) {
        lines.push(count);
      }
    } else {
      lines.push(count);
      count = 1;
      curr = bmp[_col2];
    }
  }

  return {
    lines: lines,
    padding: padding
  };
}

module.exports = {
  getImageDataFromSource: getImageDataFromSource,
  getLines: getLines
};